var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-form__tip" },
    [
      _vm.options.length > 1
        ? _c(
            "div",
            { staticClass: "checkout-form__tip-buttons" },
            _vm._l(_vm.options, function(option, index) {
              return _c(
                "label",
                { key: index, staticClass: "checkout-form__tip-button" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedOptionIndex,
                        expression: "selectedOptionIndex"
                      }
                    ],
                    staticClass: "checkout-form__tip-button-input",
                    attrs: {
                      type: "radio",
                      name: _vm.uniqueId,
                      disabled: _vm.locked
                    },
                    domProps: {
                      value: index,
                      checked: _vm._q(_vm.selectedOptionIndex, index)
                    },
                    on: {
                      input: function($event) {
                        return _vm.onSelect(option, index)
                      },
                      change: function($event) {
                        _vm.selectedOptionIndex = index
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "checkout-form__tip-button-text",
                    domProps: { innerHTML: _vm._s(option.label) }
                  })
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedOption && _vm.selectedOption.range
        ? _c("FormInputRange", {
            staticClass: "checkout-form__tip-input",
            attrs: {
              min: _vm.selectedOption.range.min || 0,
              max: _vm.selectedOption.range.max || 100,
              step: _vm.selectedOption.range.step || 1,
              "hide-value": "",
              disabled: _vm.locked
            },
            model: {
              value: _vm.rangeValue,
              callback: function($$v) {
                _vm.rangeValue = _vm._n($$v)
              },
              expression: "rangeValue"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedOption && _vm.selectedOption.type !== "none"
        ? _c("div", { staticClass: "checkout-form__tip-value" }, [
            _vm.selectedOption.type === "percent"
              ? _c("span", {
                  staticClass: "checkout-form__tip-value-percent",
                  domProps: { innerHTML: _vm._s(_vm.tipPercent + "%") }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", {
              staticClass: "checkout-form__tip-value-currency",
              domProps: { innerHTML: _vm._s(_vm.displayValue) }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "additional-info text--highlight" }, [
        _c("span", {
          domProps: { innerHTML: _vm._s(_vm.$t("cart.tipMessage")) }
        }),
        _vm._v(" "),
        _vm.tip
          ? _c("span", {
              domProps: { innerHTML: _vm._s(_vm.$t("cart.tipMessageThanks")) }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }